import React from 'react';
import './App.css';
//import { createBrowserHistory } from 'history';
import ApplicationContext from './ApplicationContext';

import Menu from './Menu';
import Header from './Header';
import Body from './Body';

function App() {

  //let history = createBrowserHistory();

  function scrollto(e){

    const element = document.getElementById(e);

    const topPos = element.getBoundingClientRect().top + window.pageYOffset - 80;

    window.scrollTo({
      top: topPos,
      behavior: 'smooth'
    });
  }

  function toggleMenu(){
    const hamburguer_items = document.getElementById('hamburguer_items');

    if(hamburguer_items.classList.contains('Menu_hamburguer_items_collapsed')){
      hamburguer_items.classList.remove('Menu_hamburguer_items_collapsed');
      hamburguer_items.classList.add('Menu_hamburguer_items_full');
    }
    else if(hamburguer_items.classList.contains('Menu_hamburguer_items_full')){
      hamburguer_items.classList.remove('Menu_hamburguer_items_full');
      hamburguer_items.classList.add('Menu_hamburguer_items_collapsed');
    }
  }

  
  window.addEventListener('scroll', () => {
    const header = document.getElementById('header');
    const menu = document.getElementById('menu');
    const menu_hamburguer = document.getElementById('Menu_hamburguer');
    const header_top = header.getBoundingClientRect().top;
    const header_height = header.getBoundingClientRect().height;
    const limit = header_height * 0.5 * (-1);
    
    if(header_top < limit){
      menu.classList.remove('Menu_bar_full');
      menu.classList.add('Menu_bar_collapsed');

      menu_hamburguer.classList.remove('Menu_hamburguer_menu_full');
      menu_hamburguer.classList.add('Menu_hamburguer_menu_collapsed');
    }
    else{
      menu.classList.remove('Menu_bar_collapsed');
      menu.classList.add('Menu_bar_full');

      menu_hamburguer.classList.remove('Menu_hamburguer_menu_collapsed');
      menu_hamburguer.classList.add('Menu_hamburguer_menu_full');
    }
  });

  return (
    <div id='app' className="App">
      <ApplicationContext.Provider value={{scrollto, toggleMenu}}>
        <Menu />
        <Header />
        <Body />
      </ApplicationContext.Provider>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js